import React from 'react';
import { Route } from 'react-router-dom';
import {
  AdminPage,
  ContentPreviewPage
} from './lazyImports';

// ========================================
// ADMIN ROUTES
// Admin Panel & CMS Preview
// IMPORTANT: These routes MUST be rendered before wildcard routes
// ========================================

const adminRoutes = [
  <Route key="admin" path="/admin" element={<AdminPage />} />,
  <Route key="content-preview" path="/content-preview" element={<ContentPreviewPage />} />
];

export default adminRoutes;
